// For sale status badges (draft, active, closed)
export const getSaleStatusBadgeStyles = (status: string) => {
  switch (status) {
    case "active":
      return {
        backgroundColor: "rgba(34, 197, 94, 0.2)",
        color: "rgb(134, 239, 172)", // green-300
        borderColor: "rgba(34, 197, 94, 0.3)", // green with opacity
      }
    case "draft":
      return {
        backgroundColor: "rgba(245, 158, 11, 0.2)",
        color: "rgb(252, 211, 77)", // amber-300
        borderColor: "rgba(245, 158, 11, 0.3)", // amber with opacity
      }
    case "closed":
    default:
      return {
        backgroundColor: "rgba(107, 114, 128, 0.2)",
        color: "rgb(209, 213, 219)", // gray-300
        borderColor: "rgba(107, 114, 128, 0.3)", // gray with opacity
      }
  }
}

// For bidding status badges (open, future, closed)
export const getBiddingStatusBadgeClasses = (biddingStatus: string): string => {
  switch (biddingStatus) {
    case "open":
      return "bg-green-100 text-green-800 border-green-200"
    case "future":
      return "bg-blue-100 text-blue-800 border-blue-200"
    case "closed":
    default:
      return "bg-gray-100 text-gray-800 border-gray-200"
  }
}

// For specific status badges in SaleDetail
export const getDraftBadgeClasses = (): string => {
  return "bg-amber-100 text-amber-800 border-amber-200"
}

export const getBadgeBaseClasses = (): string => {
  return "px-2 py-1 text-xs font-semibold uppercase tracking-wide rounded border"
}

// Get full badge className for bidding status
export const getBiddingStatusBadgeClassName = (
  biddingStatus: string
): string => {
  return `${getBadgeBaseClasses()} ${getBiddingStatusBadgeClasses(
    biddingStatus
  )}`
}

// Get badge label text
export const getBiddingStatusLabel = (biddingStatus: string): string => {
  switch (biddingStatus) {
    case "open":
      return "Bidding Open"
    case "future":
      return "Bidding Opens Soon"
    case "closed":
    default:
      return "Bidding Closed"
  }
}
